import 'gantt-task-react/dist/index.css';
import {Task, Gantt, ViewMode} from 'gantt-task-react';

const tasks: Task[] = [
  {
    start: new Date(2024, 0, 1),

    end: new Date(2024, 0, 25),

    name: 'Setup',

    id: 'Task 0',

    type: 'task',

    progress: 100,

    isDisabled: true,
    hideChildren: true,
    styles: {progressColor: '#5e6b7b', progressSelectedColor: '#5e6b7b'}
  },

  {
    start: new Date(2024, 0, 26),

    end: new Date(2024, 1, 25),

    name: 'ETL Small Scale',

    id: 'Task 1',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#b8d4ef', progressSelectedColor: '#b8d4ef'}
  },

  {
    start: new Date(2024, 1, 26),

    end: new Date(2024, 3, 5),

    name: 'ETL Full Scale',

    id: 'Task 2',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#7aaee0', progressSelectedColor: '#7aaee0'}
  },

  {
    start: new Date(2024, 3, 6),

    end: new Date(2024, 4, 6),

    name: 'Production',

    id: 'Task 3',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#628bb3', progressSelectedColor: '#628bb3'}
  },

  {
    start: new Date(2024, 4, 7),

    end: new Date(2024, 4, 14),

    name: 'Go-Live',

    id: 'Task 4',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#7be979', progressSelectedColor: '#7be979'}
  }
];
const taskses: Task[] = [
  {
    start: new Date(2024, 0, 26),

    end: new Date(2024, 2, 2),

    name: 'Setup',

    id: 'Task 1',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#5e6b7b', progressSelectedColor: '#5e6b7b'}
  },

  {
    start: new Date(2024, 2, 3),

    end: new Date(2024, 3, 3),

    name: 'ETL Small Scale',

    id: 'Task 2',

    type: 'task',

    progress: 100,
    styles: {progressColor: '#b8d4ef', progressSelectedColor: '#b8d4ef'}
  },

  {
    start: new Date(2024, 3, 4),

    end: new Date(2024, 4, 14),

    name: 'ETL Full Scale',

    id: 'Task 3',

    type: 'task',

    progress: 100,
    styles: {progressColor: '#7aaee0', progressSelectedColor: '#7aaee0'}
  },
  {
    start: new Date(2024, 4, 15),

    end: new Date(2024, 4, 26),

    name: 'Production',

    id: 'Task 4',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#628bb3', progressSelectedColor: '#628bb3'}
  },

  {
    start: new Date(2024, 4, 26),

    end: new Date(2024, 5, 1),

    name: 'Go-Live',

    id: 'Task 5',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#7be979', progressSelectedColor: '#7be979'}
  }
];
const taskse: Task[] = [
  {
    start: new Date(2024, 2, 3),

    end: new Date(2024, 3, 3),

    name: 'Setup',

    id: 'Task 1',

    type: 'task',

    progress: 100,
    styles: {progressColor: '#5e6b7b', progressSelectedColor: '#5e6b7b'}
  },

  {
    start: new Date(2024, 3, 4),

    end: new Date(2024, 4, 14),

    name: 'ETL Small Scale',

    id: 'Task 2',

    type: 'task',

    progress: 100,
    styles: {progressColor: '#b8d4ef', progressSelectedColor: '#b8d4ef'}
  },
  {
    start: new Date(2024, 4, 15),

    end: new Date(2024, 5, 17),

    name: 'ETL Full Scale',

    id: 'Task 3',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#7aaee0', progressSelectedColor: '#7aaee0'}
  },

  {
    start: new Date(2024, 5, 18),

    end: new Date(2024, 6, 4),

    name: 'Production',

    id: 'Task 4',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#628bb3', progressSelectedColor: '#628bb3'}
  },

  {
    start: new Date(2024, 6, 5),

    end: new Date(2024, 6, 10),

    name: 'Go-Live',

    id: 'Task 5',

    type: 'task',

    progress: 100,

    styles: {progressColor: '#7be979', progressSelectedColor: '#7be979'}
  }
];

const ARProjectplanDashboard: React.FC = () => (
  <div style={{}}>
    <div
      style={{
        border: 'solid 1px #45a5ce ',
        margin: '0px 0px 0px 26px',
        borderRadius: '13px',
        marginBottom: '5px'
      }}>
      <div style={{fontSize: 'large', fontWeight: '600'}}>
        <text>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Allscripts - Pro (Ephrata)
        </text>
      </div>
      <Gantt tasks={tasks} viewMode={ViewMode.Week} rowHeight={45} />
    </div>
    <div
      style={{
        border: 'solid 1px #45a5ce ',
        margin: '0px 0px 0px 26px',
        borderRadius: '13px',
        marginBottom: '5px'
      }}>
      <div style={{fontSize: 'large', fontWeight: '600'}}>
        <text>
          {' '}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Allscripts - Pro (Gettysburg)
        </text>
      </div>
      <Gantt tasks={taskses} viewMode={ViewMode.Week} rowHeight={45} />
    </div>
    <div
      style={{
        border: 'solid 1px #45a5ce ',
        margin: '0px 0px 0px 26px',
        borderRadius: '13px',
        marginBottom: '5px'
      }}>
      <div style={{fontSize: 'large', fontWeight: '600'}}>
        <text>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Allscripts - Touchworks
        </text>
      </div>
      <Gantt tasks={taskse} viewMode={ViewMode.Week} rowHeight={45} />
    </div>
  </div>
);
export default ARProjectplanDashboard;
